import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from '@feathr/components';
import DateRangeSelect from '@feathr/extender/components/DateRangeSelect';
import { flattenError } from '@feathr/hooks';

import type { IDateRangeSection } from './EmailActivityTab/EmailActivityTab.hooks';
import type { ISharedFormSlice } from './GroupExportModal.types';

type TEmailFields = Pick<
  ISharedFormSlice,
  'email' | 'emailHadFocus' | 'emailError' | 'handleChangeEmail' | 'handleEmailBlur'
>;

export interface ITimeFrameAndEmailFieldsProps {
  state: IDateRangeSection & TEmailFields;
}

function TimeFrameAndEmailFields({ state }: Readonly<ITimeFrameAndEmailFieldsProps>): JSX.Element {
  const { t } = useTranslation();
  const {
    selectedDateRange,
    customDateRange,
    dateRangeHadFocus,
    dateRangeOptions,
    dateRangeError,
    handleDateRangeChange,
    handleCustomDateRangeChange,
    email,
    emailHadFocus,
    emailError,
    handleChangeEmail,
    handleEmailBlur,
  } = state;

  const dateRangeValidationError = dateRangeHadFocus ? dateRangeError : undefined;
  const emailValidationError = emailHadFocus ? flattenError(emailError) : undefined;

  return (
    <>
      <DateRangeSelect
        customDateRange={customDateRange}
        dateRangeOptions={dateRangeOptions}
        label={t('Time frame')}
        menuPortalTarget={document.body}
        name={'time-frame'}
        onCustomDateRangeChange={handleCustomDateRangeChange}
        onDateRangeChange={handleDateRangeChange}
        selectedDateRange={selectedDateRange}
        validationError={dateRangeValidationError}
      />
      <Input
        helpText={t('If you want to send the report to a different email address.')}
        isClearable={true}
        label={t('Email address')}
        onBlur={handleEmailBlur}
        onChange={handleChangeEmail}
        type={'text'}
        validationError={emailValidationError}
        value={email}
      />
    </>
  );
}

export default TimeFrameAndEmailFields;
